module.exports = __webpack_public_path__ + "img/logo.62b48553.png";